module.exports = __webpack_public_path__ + "static/media/9DESA1.35fb07c5.jpg";